import React from 'react'
import './ContentHeader.css'
import { ChildrenProps } from '../../modules/types'

function ContentHeader(props: ChildrenProps) {
  return (
    <header id="content-header">
      {props.children}
    </header>
  )
}

export default ContentHeader
